import { evaluate } from "./evaluate/evaluate.qwik.mjs";
function getBlockComponentOptions(block, context) {
  var _a;
  return {
    ...(_a = block.component) == null ? void 0 : _a.options,
    ...block.options,
    ...evaluateTextComponentTextOption(block, context)
  };
}
const evaluateTextComponentTextOption = (block, context) => {
  var _a, _b;
  if (((_a = block.component) == null ? void 0 : _a.name) === "Text" && ((_b = block.component.options) == null ? void 0 : _b.text) && typeof block.component.options.text === "string")
    return {
      ...block.component.options,
      text: block.component.options.text.replace(/{{([^}]+)}}/g, (_match, group) => evaluate({
        code: group,
        context,
        localState: context.localState,
        rootState: context.rootState,
        rootSetState: context.rootSetState
      }))
    };
};
export {
  getBlockComponentOptions
};
